var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.75L9.44015 7.76255C9.36095 9.0432 9.3214 9.68355 9.0004 10.144C8.84165 10.3716 8.63735 10.5637 8.40035 10.708C7.92105 11 7.2795 11 5.99635 11C4.71156 11 4.06915 11 3.58952 10.7074C3.3524 10.5628 3.148 10.3704 2.98934 10.1424C2.66844 9.6813 2.62972 9.04005 2.5523 7.7576L2.25 2.75",
    stroke: "#7C7C7C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.75L9.44015 7.76255C9.36095 9.0432 9.3214 9.68355 9.0004 10.144C8.84165 10.3716 8.63735 10.5637 8.40035 10.708C7.92105 11 7.2795 11 5.99635 11C4.71156 11 4.06915 11 3.58952 10.7074C3.3524 10.5628 3.148 10.3704 2.98934 10.1424C2.66844 9.6813 2.62972 9.04005 2.5523 7.7576L2.25 2.75",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.75L9.44015 7.76255C9.36095 9.0432 9.3214 9.68355 9.0004 10.144C8.84165 10.3716 8.63735 10.5637 8.40035 10.708C7.92105 11 7.2795 11 5.99635 11C4.71156 11 4.06915 11 3.58952 10.7074C3.3524 10.5628 3.148 10.3704 2.98934 10.1424C2.66844 9.6813 2.62972 9.04005 2.5523 7.7576L2.25 2.75",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.75L9.44015 7.76255C9.36095 9.0432 9.3214 9.68355 9.0004 10.144C8.84165 10.3716 8.63735 10.5637 8.40035 10.708C7.92105 11 7.2795 11 5.99635 11C4.71156 11 4.06915 11 3.58952 10.7074C3.3524 10.5628 3.148 10.3704 2.98934 10.1424C2.66844 9.6813 2.62972 9.04005 2.5523 7.7576L2.25 2.75",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.75H10.5M8.02785 2.75L7.68655 2.04587C7.4598 1.57813 7.3464 1.34426 7.15085 1.19841C7.1075 1.16605 7.06155 1.13727 7.0135 1.11235C6.79695 1 6.53705 1 6.01725 1C5.4844 1 5.218 1 4.99784 1.11706C4.94905 1.143 4.90249 1.17295 4.85864 1.20659C4.66082 1.35835 4.55032 1.60078 4.32931 2.08563L4.02646 2.75",
    stroke: "#7C7C7C",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.75H10.5M8.02785 2.75L7.68655 2.04587C7.4598 1.57813 7.3464 1.34426 7.15085 1.19841C7.1075 1.16605 7.06155 1.13727 7.0135 1.11235C6.79695 1 6.53705 1 6.01725 1C5.4844 1 5.218 1 4.99784 1.11706C4.94905 1.143 4.90249 1.17295 4.85864 1.20659C4.66082 1.35835 4.55032 1.60078 4.32931 2.08563L4.02646 2.75",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.75H10.5M8.02785 2.75L7.68655 2.04587C7.4598 1.57813 7.3464 1.34426 7.15085 1.19841C7.1075 1.16605 7.06155 1.13727 7.0135 1.11235C6.79695 1 6.53705 1 6.01725 1C5.4844 1 5.218 1 4.99784 1.11706C4.94905 1.143 4.90249 1.17295 4.85864 1.20659C4.66082 1.35835 4.55032 1.60078 4.32931 2.08563L4.02646 2.75",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.75H10.5M8.02785 2.75L7.68655 2.04587C7.4598 1.57813 7.3464 1.34426 7.15085 1.19841C7.1075 1.16605 7.06155 1.13727 7.0135 1.11235C6.79695 1 6.53705 1 6.01725 1C5.4844 1 5.218 1 4.99784 1.11706C4.94905 1.143 4.90249 1.17295 4.85864 1.20659C4.66082 1.35835 4.55032 1.60078 4.32931 2.08563L4.02646 2.75",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.25V5.25",
    stroke: "#7C7C7C",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.25V5.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.25V5.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.25V5.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.25V5.25",
    stroke: "#7C7C7C",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.25V5.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.25V5.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.25V5.25",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f4ce0ab477630bb7b15d4b9d85993b8b.svg";
export { ForwardRef as ReactComponent };